import Vue from 'vue';

const success = (context, response) => {
  $('.cancel').removeClass('disabled');
  $('.confirm').removeClass('disabled');
  swal(context.$t('rentals.detail.modals.deleted_success'), context.$t('rentals.detail.modals.deleted_success'), 'success');
  context.loading = false;
  localStorage.removeItem(`calendar_${context.account.id}_filtered_rental_ids`);
  Vue.router.push({
    name: 'rentals.index',
  });
};

const failed = (context, error) => {
  if (error && error.response && error.response.data && error.response.data.rentalHaveBookings) {
    context.removeWithBookings();
  } else {
    swal('Error', context.$t('rentals.detail.modals.something_went_wrong'), 'error');
    context.showToasterError(error);
  }
};

export default (context, id, onlyOurSide = false) => Vue.$http.post(`/rentals/${id}`, { _method: 'delete', onlyOurSide })
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data);
      }
    }).catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/rental/destroy.js